<template>
  <mk-drawer-biz-two
    :visible="visible"
    size="820px"
    :before-close="handleBeforeClose"
    @close="handleOnDrawerCloseClick"
  >
    <!-- header 头部区域 -->
    <template slot="title">
      <span class="company-title">公司基本信息设置</span>
    </template>
    <!-- 中间区域 -->
    <mk-form
      ref="form"
      :model="params"
      label-position="right"
      label-width="90px"
      :rules="rules"
    >
      <mk-form-item
        label="公司名称:"
        prop="companyName"
      >
        <mk-input
          v-model="params.companyName"
          width="370"
          placeholder="请输入公司名称"
        >
        </mk-input>
      </mk-form-item>
      <mk-form-item
        label="公司头像:"
      >
        <upload-biz
          :data="params.companyImg"
          @on-upload-success="handleOnCompanyImgUploadSuccess"
          @on-delete-click="handleOnCompanyImgDeleteClick"
        >
        </upload-biz>
      </mk-form-item>
      <mk-form-item
        label="公司背景图:"
      >
        <upload-biz
          :data="params.companyBackgroundImg"
          @on-upload-success="handleOnCompanyBackgroundImgUploadSuccess"
          @on-delete-click="handleOncompanyBackgroundImgDeleteClick"
        >
        </upload-biz>
      </mk-form-item>
    </mk-form>
    <!-- 底部操作 -->
    <template
      slot="bottom"
    >
      <mk-button
        size="small"
        @click="handleOnCancelClick"
      >
        取消
      </mk-button>
      <mk-button
        size="mini"
        type="primary"
        @click="handleOnSaveClick('form')"
      >
        保存
      </mk-button>
    </template>
  </mk-drawer-biz-two>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import { CARDAPIS } from '@api'
export default {
  name: 'Company',
  components: { MkDrawerBizTwo },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
        companyBackgroundImg: this.data.companyBackgroundImg,
        companyImg: this.data.companyImg,
        companyName: this.data.companyName
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleBeforeClose () {
    },
    handleOnDrawerCloseClick () {
      this.$emit('close')
    },
    handleOnCancelClick () {
      this.$emit('close')
    },
    handleOnSaveClick (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.companyCardCompanyUpdatePost(this.params)
        } else {
          return false
        }
      })
    },
    handleOnCompanyImgUploadSuccess (cover) {
      this.params.companyImg = cover
    },
    handleOnCompanyImgDeleteClick () {
      this.params.companyImg = ''
    },
    handleOnCompanyBackgroundImgUploadSuccess (cover) {
      this.params.companyBackgroundImg = cover
    },
    handleOncompanyBackgroundImgDeleteClick () {
      this.params.companyBackgroundImg = ''
    },
    async companyCardCompanyUpdatePost () {
      const { success, data, msg } = await CARDAPIS.CardApi.companyCardCompanyUpdatePost(this.params)
      if (success) {
        this.$message.success('保存成功！')
        this.$emit('close')
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.company-title {
  font-weight: 500;
}
</style>
